import { SingletonEnginnering } from "../singletonEngineering"
import Properties from "../../_model/ModelEngineeringProperties"
import { Types } from "../../../utils/nodeTypes";
import { SingletonFlowchart } from "../singletonFlowchart";

const EquipmentJoker = {
  areaNotConfig: "Operação não configurada na area",
  capacityTxTList: ["CAPACIDADE", "AREA", "VOLUME", "CAPPRODUCAO", "CAPACIDADEFILTRACAO", "CAPACIDADEINSTALADA"],
  occupancyTxTList: ["OCUPACAO", "TAXAOCUPACAO", "TXUTILIZACAO"],
  onOffTxTList: ["STATUS", "QUANTIDADE"],

  FindJoker: function(key){
    let founded = []
    let keyRequiredEquipmentList = SingletonEnginnering.getOperationsEquipments(key)
    let keyEquipamentsPropertiesList = SingletonEnginnering.getEquipamentsProperties(key)

    // Procura Operações em todo o engenharia
    for(let i in SingletonEnginnering.operations){
      let op = SingletonEnginnering.operations[i]
      let { opEquipmentsFound,  eqProps,  atProps} = {...this.getConfigurationsToFindJoker(op)}

      let hasEquipment = opEquipmentsFound.length <= 0
      let sameKey = key == op
      let namesNotIsEquals = !this.equipmentsIsSame(key, op)
      let isJokerName = !keyRequiredEquipmentList.find(req => opEquipmentsFound.find(found => found == req))

      if( hasEquipment || sameKey || namesNotIsEquals || isJokerName )      
        continue         
      
      for(let j in opEquipmentsFound){
        let opEqName = opEquipmentsFound[j]
        let keyEqProps = keyEquipamentsPropertiesList[opEqName]
        let wasAdd = founded.find(joker => joker.op == op)

        // Se as key buscada não possuí propriedades pula
        if(!keyEquipamentsPropertiesList || !keyEqProps || wasAdd)
          continue;
        
        let capacityFound = this.getPropCapacity(eqProps[opEqName])
        let capacityRequired = this.getPropCapacity(keyEqProps)
        
        if(!capacityRequired || capacityRequired.value != capacityFound.value)
          continue
        
        let nameEquip = opEquipmentsFound
        let equipmentJoker = opEqName
        let area = this.areaNotConfig
        founded.push({ op, nameEquip, atProps, eqProps, area, equipmentJoker })
      }   
    }
    return founded
  },

  getConfigurationsToFindJoker(op){
    return {
      opEquipmentsFound: SingletonEnginnering.getOperationsEquipments(op),
      eqProps: SingletonEnginnering.getEquipamentsProperties(op),
      atProps: SingletonEnginnering.getOperationsProperties(op)
    }
  },

  getPropCapacity(array){
    if(!array) return null
    return array.find(prop => this.capacityTxTList.includes(prop.key.toUpperCase()))
  },

  equipmentsIsSame(key1 = new String, key2 = new String){
    let equipRequired = key1.split("|")[0]
    let equipFound = key2.split("|")[0]

    return equipRequired.includes(equipFound) || equipFound.includes(equipRequired)
  },

  SetAreaWithEquipment(areas, jokerList) {
    let newJokerAdd = []
    for(let i in jokerList){
      let j = jokerList[i]
      for(let k in areas) {
        let a = areas[k]
        if(!this.HasOperationInArea(a, j.op))
          continue

        if(j.area == this.areaNotConfig)
        {
          j.area = a.area
          this.SetPropsNodesInJoker(a.configuration, j)
        }
        else
        {
          let newJoker = JSON.parse(JSON.stringify(j))
          newJoker.area = a.area
          newJoker.atProps = newJoker.atProps.map(at => new Properties({...at}))

          newJoker.nameEquip.forEach(e => {
            if(newJoker.eqProps[e])
              newJoker.eqProps[e] = newJoker.eqProps[e].map(eq => new Properties({...eq}))
          })
          this.SetPropsNodesInJoker(a.configuration, newJoker)
            newJokerAdd.push(newJoker)
        }
      }
    }

    return newJokerAdd
  },

  SetPropsNodesInJoker(configuration, joker){
    let node = this.FindNodeInConfiguration(configuration, joker.op)
    if(node){
      let propList = this.FindPropsInData(node.data, joker.op)
      for(let j in propList){
        this.SetPropertiesInJoker(propList[j], joker)
      }
    }
  },

  UpdateNodes(areas, jokerList, currentArea){
    let memoryNodes = []
    for(let i in jokerList){
      let joker = jokerList[i]

      for(let j in areas){
        let flow = areas[j]
        let node = this.findNodeByOperation(flow.configuration, joker.op)
        
        if(!node) continue;
        
        let propList = this.FindPropsInData(node.data, joker.op);

        for(let j in propList)
          this.SetPropertiesJokerInProp(propList[j], joker)
        
        if(flow.area == currentArea)
          memoryNodes.push(node)
      }
    }
    return memoryNodes
  },

  findNodeByOperation(nodes, index){
    let founded;
    for(let i in nodes){
      if(nodes[i].data[0] && this.refuseTypes(nodes[i]) && nodes[i].data[0].index == index){
        founded = nodes[i]
        break;
      }
    }
    return founded
  },

  HasSameEquipment(searchFor, equipmentList){
    let result = false;
    for(let i in searchFor){
      let equipment  = searchFor[i]
      if(equipmentList.find(e => e == equipment))
        result = true
    }
    return result;
  },

  HasOperationInArea(flow, op){
    return !!this.FindNodeInConfiguration(flow.configuration, op);
  },

  HasOperationInNode(node, op){
    return this.FindPropsInData(node.data, op).length > 0
  },

  FindNodeInConfiguration(configuration, op){
    let nodeFound = null
    for(let i in configuration){
      let node = configuration[i]
      if(this.refuseTypes(node) && this.HasOperationInNode(node, op)){
        nodeFound = node;
        nodeFound.data = node.data.map(p => new Properties({...p}))
      }
    }
    return nodeFound
  },

  refuseTypes(node){
    let types = new Types()
    return  node.type != types.Input && 
            node.type != types.Current &&
            node.type != types.Occupation &&
            node.type != types.MultipleInput &&
            node.type != types.ProductionChangeEditable &&
            node.type != types.InputCana &&
            node.type != types.OnOff
  },

  FindPropsInData(data, op){
    let prop = [];
    for(let i in data)
    {
      if(data[i].index == op)
        prop.push(data[i])
    }
    return prop
  },

  SetPropertiesInJoker(prop, joker){
    for(let i in joker.atProps){
      let atProp = joker.atProps[i]
      this.SetPropertie(atProp, prop)
    }
    
    joker.nameEquip.forEach(name => {
      let eqProps = joker.eqProps[name]
      for(let i in eqProps){
        let eqProp = eqProps[i]
        this.SetPropertie(eqProp, prop)
      }
    })
  },

  SetPropertiesJokerInProp(prop, joker){
    for(let i in joker.atProps){
      let atProp = joker.atProps[i]
      this.SetPropertie(prop, atProp)
    }
    
    for(let i in joker.equipments){
      let eqProp = joker.equipments[i]
      this.SetPropertie(prop, eqProp)
    }
  },

  SetPropertie(target, seter){
    if(target.constructor.name != 'Object' && target.isEquals(seter)){
      target.value = seter.value
      SingletonEnginnering.setValue(target)      
    }
  },
}

export default EquipmentJoker